import React, { HTMLProps, Ref, forwardRef } from 'react';
import { cn } from '../../../utils';

type TextAreaInputProps = HTMLProps<HTMLTextAreaElement> & {
  extraClassname?: string;
  error?: boolean;
};

export const TextAreaInput = forwardRef(
  (props: TextAreaInputProps, ref: Ref<HTMLTextAreaElement>) => {
    const { extraClassname, error, ...rest } = props;

    return (
      <textarea
        rows={1}
        {...rest}
        ref={ref}
        className={cn(
          '!shadow-[0_0_0_1px] !shadow-evolve-primary !rounded-none !border-evolve-primary !border !p-2 !text-sm focus-visible:!border-evolve-highlight-50 focus-visible:!shadow-evolve-highlight-50 focus-visible:!outline-none',
          extraClassname,
          { '!border-red-500 !shadow-red-500': error },
          { '!bg-evolve-secondary': rest.disabled }
        )}
      />
    );
  }
);

TextAreaInput.displayName = 'TextAreaInput';
